exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "a.dropdown-item{font-size:14px}", "", {"version":3,"sources":["/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/reservations/reservation-button-bar/reservation-button-bar.component.css"],"names":[],"mappings":"AAAA,gBACE,cAAgB,CACjB","file":"reservation-button-bar.component.css","sourcesContent":["a.dropdown-item {\n  font-size: 14px;\n}"],"sourceRoot":""}]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/reservations/reservation-button-bar/reservation-button-bar.component.css
// module id = 57PB
// module chunks = 0